import { RequestFailure } from '@owl-nest/api-client'
import { Status } from '@owl-nest/redux-wrapper'
import * as api from '@owl-nest/api-client/latest'

import { TYPE, Action } from '../actions/events'

export type State = {
  cacheId?: number
  draftNews: api.News<false, true>[]
  list?: {
    next: string | null
    events: api.Event[]
  }

  status: {
    load:
      | { status: Status.PRISTINE | Status.PENDING | Status.SUCCESS }
      | { status: Status.FAILURE; failure: RequestFailure }
  }
}

const initialState: State = {
  draftNews: [],
  status: { load: { status: Status.PRISTINE } },
}

export function reducer(state = initialState, action: Action): State {
  switch (action.type) {
    case TYPE.LOAD_REQUEST: {
      return {
        ...state,
        status: {
          ...state.status,
          load: { status: Status.PENDING },
        },
      }
    }
    case TYPE.LOAD_FAILURE: {
      return {
        ...state,
        status: {
          ...state.status,
          load: { status: Status.FAILURE, failure: action.failure },
        },
      }
    }
    case TYPE.LOAD_SUCCESS: {
      if (action.success.cacheId !== state.cacheId || state.list === undefined || action.success.forceClean) {
        return {
          ...state,
          draftNews: action.success.draft_news || [],
          cacheId: action.success.cacheId,
          list: {
            events: [...(action.success.events || [])],
            next: action.success.meta.next,
          },
          status: {
            ...state.status,
            load: { status: Status.SUCCESS },
          },
        }
      } else {
        return {
          ...state,
          draftNews: action.success.draft_news || state.draftNews,
          list: {
            events: [...state.list.events, ...(action.success.events || [])],
            next: action.success.meta.next,
          },
          status: {
            ...state.status,
            load: { status: Status.SUCCESS },
          },
        }
      }
    }
    case TYPE.RESET: {
      return initialState
    }
  }

  return state
}
